import "./ViaviMicroNir.module.css";
import Header from "@/reusable_sections/Header";
import MicronirHero from "./sections/MicronirHero";
import Portfolio from "./sections/Portfolio";
import DiscussApplication from "./sections/DiscussApplication";
import Footer from "@/reusable_sections/Footer";
export default function ViaviMicroNirPage() {
  return <div>
      <Header />
      <MicronirHero />
      <Portfolio />
      <DiscussApplication />
      <Footer />
    </div>;
}